import React, { useEffect, Fragment, useRef } from 'react';
import NotificationAlert from "react-notification-alert";
import { notificationService } from "services/notifications/NotificationService";
import { useDispatch } from 'react-redux';
import { logoutAuth } from 'services/http/auth';

const Notification = () => {
  const notificationAlert = useRef(null)
  const dispatch = useDispatch();

  useEffect(() => {

    const logout2 = () => {
      dispatch(logoutAuth());
    }
    // subscribe to loading
    const subscription = notificationService.getMessage().subscribe(message => {
      if (message.type === "logout") {
        logout2();
      }
      else if (message.type === "CLIENT_DETAIL_RESET") {
        dispatch({
          type: "CLIENT_DETAIL_RESET"
        })

      } else {
        if (message) {
          const autoDismiss = message.autoDismiss ? message.autoDismiss : 7;// SET THE DEFAULT 7 IF NOT SET.
          notify(message.type, message.message, message.heading, autoDismiss);
        }
      }
    });
    // clean up function that runs when the component unmounts
    return () => {
      // unsubscribe & unlisten to avoid memory leaks
      subscription.unsubscribe();
    };
  }, [dispatch]);


  const notify = (type, message, heading, autoDismiss = 7) => {
    let options = {
      place: "tr",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {heading}
          </span>
          <span className="pl-1" data-notify="message">
            {message}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: autoDismiss
    };
    notificationAlert.current.notificationAlert(options);
  };


  return (
    <Fragment>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlert} />
      </div>
    </Fragment>
  );
}

export default Notification;